/**
 * The page's four anchor sections, in navigation order.
 *
 * `id` doubles as the `<section id>` and the `#hash` the nav links to, and is
 * what the scroll-spy observer reports. The order here mirrors DOM order, so
 * scrolling the page moves the underline left to right. (The design mockup
 * listed Services before About; following it left the second nav item jumping
 * past the third, so the nav follows the page instead.)
 */
export const NAV_SECTIONS = [
  { id: 'home', labelKey: 'nav.home' },
  { id: 'about', labelKey: 'nav.about' },
  { id: 'services', labelKey: 'nav.services' },
  { id: 'contact', labelKey: 'nav.contact' },
] as const

export type NavSectionId = (typeof NAV_SECTIONS)[number]['id']
